// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { toast } from "react-toastify";
// import "../css/DailyPunchedAttendence.css";
// import { format } from "date-fns";
// import { BASE_URL } from "../config";
// import { getAuthHeaders } from "../services/useAuth";
// import SmsModal from "../Admin/DailyPunchSheets/SmsModal";
// import EmployeeMapTracker from "../../src/pages/EmployeeMapTracker";
// import RedFlag from "../images/RedFlag.png";
// import GreenFlag from "../images/GreenFlag.png";
// import Loader from "../dist/Loader";
// import { CheckCircle } from "lucide-react";
// import CustomButton from "./CustomButton";
// import { formatDate } from "../utils/formatDate";
// import { formatTimeTo12Hour, formatExcelTime } from "../utils/formatTime";
// import AttendanceTable from "../Admin/AbsentDailyPunch";
// import LoadingDropdown from "../utils/LoadingDropdown";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// const DailyPunchedAttendance = () => {
//   const [states, setStates] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [employees, setEmployees] = useState([]);
//   const [selectedState, setSelectedState] = useState("");
//   const [selectedDivision, setSelectedDivision] = useState("All");
//   const [selectedEmployee, setSelectedEmployee] = useState("All");
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [tableData, setTableData] = useState([]);
//   const [showTable, setShowTable] = useState(false);
//   const [smsModal, setSmsModal] = useState({ isOpen: false, employee: null });
//   const [isFetchingStates, setIsFetchingStates] = useState(false);
//   const [isFetchingDivisions, setIsFetchingDivisions] = useState(false);
//   const [isFetchingEmployees, setIsFetchingEmployees] = useState(false);
//   const [mapModal, setMapModal] = useState({
//     isOpen: false,
//     employeeData: null,
//   });

//   const tableWrapperRef = useRef(null);
//   const formatDateForApi = (date) => {
//     if (!date) return "";
//     const dt = new Date(date);
//     const yyyy = dt.getFullYear();
//     const mm = String(dt.getMonth() + 1).padStart(2, "0");
//     const dd = String(dt.getDate()).padStart(2, "0");
//     return `${yyyy}-${mm}-${dd}`;
//   };
//   const formatDateTime = (dateString, displayTimeOnly = false) => {
//     if (!dateString) return "-";

//     const date = new Date(
//       dateString.endsWith("Z") ? dateString : `${dateString}Z`,
//     );

//     const timeOptions = {
//       timeZone: "Asia/Kolkata",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     };

//     const dateOptions = {
//       timeZone: "Asia/Kolkata",
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     };

//     const formatTime = (d) =>
//       d.toLocaleTimeString("en-IN", timeOptions).toUpperCase();

//     if (displayTimeOnly) {
//       return formatTime(date);
//     }

//     const formattedDate = date.toLocaleDateString("en-IN", dateOptions);
//     const formattedTime = formatTime(date);

//     return `${formattedDate} ${formattedTime}`;
//   };

//   const capitalizeFirst = (text) =>
//     text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "-";

//   const handleOpenAbsentWindow = () => {
//     const params = new URLSearchParams();

//     if (selectedState && selectedState !== "All") {
//       params.set("state_id", selectedState);
//     }

//     if (selectedDivision && selectedDivision !== "All") {
//       params.set("division", selectedDivision);
//     }

//     if (selectedEmployee && selectedEmployee !== "All") {
//       params.set("employee_id", selectedEmployee);
//     }

//     const quarterDate = format(selectedDate, "dd MMM yyyy");
//     params.set("quarter", quarterDate.replace(/ /g, "/"));

//     params.set("is_absent", "true");

//     const url = `/admin/absent-daily-punch?${params.toString()}`;

//     window.open(url, "_blank", "width=1000,height=700,left=200,top=100");
//   };

//   const formatDateForDisplay = (date) => {
//     if (!date) return "";
//     const d = typeof date === "string" ? new Date(date) : date;
//     return format(d, "yyyy-MM-dd");
//   };

//   // Load states
//   const loadStates = async () => {
//     setIsFetchingStates(true);
//     try {
//       const response = await axios.get(`${BASE_URL}/api/states`, {
//         headers: getAuthHeaders(),
//       });
//       const list = Array.isArray(response.data)
//         ? response.data
//         : response.data?.data || [];
//       setStates(list);
//     } catch (err) {
//       console.error("Error fetching states:", err);
//       setError("Failed to load states");
//     } finally {
//       setIsFetchingStates(false);
//     }
//   };

//   const loadEmployees = async (stateId, divisionName) => {
//     if (!stateId || stateId === "All") {
//       setEmployees([{ id: "All", first_name: "All", last_name: "" }]);
//       setSelectedEmployee("All");
//       return;
//     }

//     setIsFetchingEmployees(true); // ← add this
//     try {
//       const params = new URLSearchParams();
//       params.set("state_id", stateId);
//       if (divisionName && divisionName !== "All")
//         params.set("division", divisionName);

//       const response = await axios.get(
//         `${BASE_URL}/api/employees?${params.toString()}`,
//         { headers: getAuthHeaders() },
//       );
//       const list = Array.isArray(response.data)
//         ? response.data
//         : response.data?.data || [];
//       setEmployees([{ id: "All", first_name: "All", last_name: "" }, ...list]);
//       setSelectedEmployee("All");
//     } catch (err) {
//       console.error("Error fetching employees:", err);
//       setEmployees([{ id: "All", first_name: "All", last_name: "" }]);
//     } finally {
//       setIsFetchingEmployees(false); // ← add this
//     }
//   };

//   const onStateChange = async (stateId) => {
//     setSelectedState(stateId);
//     setSelectedDivision("All");
//     setSelectedEmployee("All");

//     if (!stateId || stateId === "All") {
//       setDivisions([{ id: "All", name: "All" }]);
//       await loadEmployees("All", "All");
//       return;
//     }
//     setIsFetchingDivisions(true);
//     try {
//       const response = await axios.get(
//         `${BASE_URL}/api/divisions?state_id=${stateId}`,
//         { headers: getAuthHeaders() },
//       );
//       const divisionsData = Array.isArray(response.data)
//         ? response.data
//         : response.data?.data || [];
//       const divisionsList = divisionsData.map((d) =>
//         typeof d === "string" ? { id: d, name: d } : d,
//       );
//       setDivisions([{ id: "All", name: "All" }, ...divisionsList]);
//     } catch (err) {
//       console.error("Error loading divisions", err);
//       setDivisions([{ id: "All", name: "All" }]);
//     } finally {
//       setIsFetchingDivisions(false);
//     }

//     await loadEmployees(stateId, "All");
//   };

//   const onDivisionChange = (division) => {
//     setSelectedDivision(division);
//     setSelectedEmployee("All");
//     loadEmployees(selectedState === "All" ? null : selectedState, division);
//   };

//   const loadAttendanceReport = async () => {
//     try {
//       setIsLoading(true);
//       setError(null);

//       const params = new URLSearchParams();
//       if (selectedState && selectedState !== "All")
//         params.set("state_id", selectedState);
//       if (selectedDivision && selectedDivision !== "All")
//         params.set("division", selectedDivision);
//       if (selectedEmployee && selectedEmployee !== "All")
//         params.set("employee_id", selectedEmployee);

//       const quarterDate = format(selectedDate, "dd MMM yyyy");
//       params.set("quarter", quarterDate.replace(/ /g, "/"));

//       const url = `${BASE_URL}/api/pob-targets/pob_target_report?${params.toString()}`;
//       const response = await axios.get(url, { headers: getAuthHeaders() });

//       const responseData = Array.isArray(response.data)
//         ? response.data
//         : response.data?.data || [];

//       // Simple mapping function
//       const transformedData = responseData.map((item, index) => {
//         const getFieldValue = (...fieldNames) => {
//           for (const fieldName of fieldNames) {
//             if (item[fieldName] !== undefined && item[fieldName] !== null)
//               return item[fieldName];
//           }
//           return "";
//         };

//         const employeeName =
//           getFieldValue("employee_name", "employee") ||
//           `${getFieldValue("first_name") || ""} ${getFieldValue("last_name") || ""
//             }`.trim();

//         return {
//           serialNumber: index + 1,
//           employeeId: getFieldValue("employee_id", "id"),
//           employeeCode: getFieldValue("employee"),
//           employeeName,
//           designation: getFieldValue("designation", "desig") || "",
//           division: getFieldValue("division") || "",
//           state: getFieldValue("state", "state_name") || "",
//           mandatoryCanLogin: getFieldValue("location_active_flag"),
//           substate:
//             getFieldValue("substate", "sub_state", "zone", "division_zone") ||
//             "",
//           headquarter:
//             getFieldValue("hq", "headquarter", "headquarter_name") || "",
//           final_joining_date:
//             getFieldValue("final_joining_date", "joining_date", "doj") || "",
//           manager: getFieldValue("manager", "manager_name") || "",
//           visits: Number(getFieldValue("visits", "visits_count")) || 0,
//           pob:
//             Number(getFieldValue("pob", "pob_value", "total", "oct_pob")) || 0,
//           locationCount:
//             Number(getFieldValue("location_count", "locations_count")) || 0,
//           gpsStop: getFieldValue("gps_stop", "gps_location", "gpsStop") || "",
//           latestLocation:
//             getFieldValue(
//               "latest_location",
//               "current_location",
//               "location",
//               "latestLocation",
//             ) || "",
//           routeName: getFieldValue("route_name", "route") || "",
//           gps_stop_idle_time:
//             getFieldValue("gps_stop_idle_time", "gps_stop_idle") || "",
//           morningFieldBy:
//             item.morning_fld_by ?? item.mor_field_by ?? item.mor_fld_by ?? "-",

//           eveningFieldBy:
//             item.evening_fld_by ?? item.eve_field_by ?? item.eve_fld_by ?? "-",

//           morningPunchTime:
//             getFieldValue("mor_punch_time", "mor_punch", "morning_in_time") ||
//             "",
//           eveningPunchTime:
//             getFieldValue(
//               "eve_punch_time",
//               "eve_punch",
//               "evening_punch_time",
//             ) || "",
//           firstCallTime: getFieldValue("first_call_time") || "",
//           lastCallTime: getFieldValue("last_call_time") || "",
//           morningStatus:
//             getFieldValue(
//               "mor_status",
//               "morning_status",
//               "attendance_status",
//             ) || "Present",
//           eveningStatus:
//             getFieldValue("eve_status", "evening_status") || "Present",
//           residenceAddress: getFieldValue("address", "residence_address") || "",
//           phone: getFieldValue("phone_no", "phone_number", "phone") || "",
//           smsStatus: getFieldValue("sms") || "No",
//         };
//       });

//       setTableData(transformedData);
//       setShowTable(true);
//     } catch (err) {
//       console.error("Error fetching attendance report:", err);
//       setError("Could not load report. Please try again.");
//       setTableData([]);
//       setShowTable(false);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const openWorkingWithWindow = (employeeId) => {
//     const stateId =
//       selectedState && selectedState !== "All" ? selectedState : "";
//     const month = format(selectedDate, "M");
//     const year = format(selectedDate, "yyyy");

//     const params = new URLSearchParams();
//     if (stateId) params.append("state_id", stateId);
//     params.append("month", month);
//     params.append("year", year);
//     params.append("employee_id", String(employeeId));

//     window.open(
//       `/admin/working-with?${params.toString()}`,
//       "_blank",
//       "width=1400,height=700",
//     );
//   };
//   const handleOpenDoctorsTPvsDCR = (record) => {
//     const params = new URLSearchParams();

//     const formattedDate = format(selectedDate, "MM/dd/yyyy");

//     params.set("working_date", formattedDate);
//     params.set("employee_id", record.employeeId);
//     params.set("emp_name", record.employeeName);
//     const url = `/admin/doctors-in-tp-vs-dcr?${params.toString()}`;
//     window.open(url, "_blank", "width=1100,height=700,left=200,top=100");
//   };
//   const openDcrPreviewWindow = (employeeId) => {
//     const dateString = formatDateForApi(selectedDate);
//     window.open(
//       `/admin/dcrpreviewtable?employee_id=${employeeId}&date=${dateString}`,
//       "_blank",
//       "width=1200,height=700",
//     );
//   };
//   const openLocationHistoryWindow = (employeeId, employeeName) => {
//     const params = new URLSearchParams();
//     params.set("employee_id", employeeId);
//     params.set("employee_name", encodeURIComponent(employeeName || ""));
//     params.set("track_date", formatDateForApi(selectedDate));

//     window.open(
//       `/reporting/location-history?${params.toString()}`,
//       "_blank",
//       "width=1400,height=700",
//     );
//   };

//   const openMapModal = (employeeData, context = "general") => {
//     console.log("Opening map modal with data:", {
//       employeeId: employeeData.employeeId,
//       employeeName: employeeData.employeeName,
//       trackDate: formatDateForApi(selectedDate),
//       context: context,
//     });

//     setMapModal({ isOpen: false, employeeData: null });

//     setTimeout(() => {
//       setMapModal({
//         isOpen: true,
//         employeeData: {
//           employeeId: String(employeeData.employeeId),
//           employeeCode: employeeData.employeeCode,
//           employeeName: employeeData.employeeName,
//           trackDate: formatDateForApi(selectedDate),
//           context: context,
//           state: employeeData.state,
//           division: employeeData.division,
//           designation: employeeData.designation,
//           residenceAddress: employeeData.residenceAddress,
//           specificPunchTime: employeeData.specificPunchTime || null,
//           routeName: employeeData.routeName || "",
//           latestLocation: employeeData.latestLocation || "",
//           gpsStop: employeeData.gpsStop || "",
//           locationCount: employeeData.locationCount ?? 0,
//           gpsStopIdleTime:
//             formatDateTime(employeeData.gps_stop_idle_time) || "",
//           visits: employeeData.visits ?? 0,
//           pob: employeeData.pob ?? 0,
//         },
//       });
//     }, 50);
//   };

//   const closeMapModal = () => {
//     setMapModal({ isOpen: false, employeeData: null });
//   };

//   const handleMorningPunchMap = (employeeData) => {
//     console.log("Morning punch clicked for:", employeeData.employeeName);
//     openMapModal(
//       { ...employeeData, specificPunchTime: employeeData.morningPunchTime },
//       "morningPunch",
//     );
//   };
//   const handleEveningPunchMap = (employeeData) => {
//     console.log("Evening punch clicked for:", employeeData.employeeName);
//     openMapModal(
//       { ...employeeData, specificPunchTime: employeeData.eveningPunchTime },
//       "eveningPunch",
//     );
//   };
//   const handleViewMap = (employeeData) => {
//     console.log("View map clicked for:", employeeData.employeeName);
//     openMapModal(employeeData, "viewMap");
//   };
//   const openSmsModal = (employee) => setSmsModal({ isOpen: true, employee });

//   useEffect(() => {
//     loadStates();
//   }, []);
//   useEffect(() => {
//     if (mapModal.isOpen && mapModal.employeeData) {
//       console.log("Map modal opened with data:", mapModal.employeeData);
//     }
//   }, [mapModal]);
//   const printableStyles = `
//     <style>
//       body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial; font-size:12px; color:#111; }
//       table { border-collapse: collapse; width: 100%; table-layout: fixed; word-break: break-word; }
//       th, td { border: 1px solid #999; padding: 6px 8px; vertical-align: middle; }
//       thead th { background: #2b6cb0; color: #fff; font-weight: 600; text-align: center; }
//       .bg-blue-100 { background-color: #ebf8ff; }
//       .text-center { text-align: center; }
//       .text-left { text-align: left; }
//       .nowrap { white-space: nowrap; }
//       .small { font-size: 11px; }
//       a { color: #1d4ed8; text-decoration: underline; }
//     </style>
//   `;

//   const getPrintableTableHtml = () => {
//     if (!tableWrapperRef.current) return "<div>No table found</div>";
//     const wrapper = tableWrapperRef.current.cloneNode(true);
//     wrapper.querySelectorAll("button").forEach((btn) => {
//       const span = document.createElement("span");
//       span.innerHTML = btn.innerHTML;
//       btn.parentNode.replaceChild(span, btn);
//     });
//     wrapper.querySelectorAll("a").forEach((a) => {
//       const href = a.getAttribute("href");
//       if (href) {
//         a.insertAdjacentText("afterend", ` (${href})`);
//       }
//     });
//     return wrapper.innerHTML;
//   };

//   const footerTotals = tableData.reduce(
//     (acc, row) => {
//       acc.totalVisits += Number(row.visits || 0);
//       acc.totalPob += Number(row.pob || 0);

//       const punched =
//         Boolean(row.morningPunchTime) || Boolean(row.eveningPunchTime);

//       if (punched) acc.punch++;
//       else acc.noPunch++;

//       const morning = (row.morningStatus || "").toLowerCase().trim();
//       const evening = (row.eveningStatus || "").toLowerCase().trim();
//       const validStatuses = ["present", "absent"];
//       if (
//         !validStatuses.includes(morning) ||
//         !validStatuses.includes(evening)
//       ) {
//         return acc;
//       }

//       if (morning === "absent" && evening === "absent") {
//         acc.absent++;
//       } else {
//         acc.present++;
//       }

//       return acc;
//     },
//     {
//       totalVisits: 0,
//       totalPob: 0,
//       punch: 0,
//       noPunch: 0,
//       present: 0,
//       absent: 0,
//     },
//   );
//   const handlePrint = () => {
//     try {
//       const tableHtml = getPrintableTableHtml();
//       const w = window.open("", "_blank", "width=1200,height=900");
//       if (!w) {
//         toast.warning("Please allow popups to enable printing.");
//         return;
//       }

//       w.document.open();
//       w.document.write(
//         `<html><head><title>Attendance Report - Print</title>${printableStyles}</head><body>`,
//       );
//       w.document.write(`<div style="margin:12px 8px;">`);
//       w.document.write(`<h2 style="margin-bottom:8px;">Attendance Report</h2>`);
//       w.document.write(tableHtml);
//       w.document.write(`</div>`);
//       w.document.write("</body></html>");
//       w.document.close();
//       w.focus();
//       setTimeout(() => {
//         try {
//           w.print();
//         } catch (e) {
//           console.error("Print failed", e);
//         }
//       }, 500);
//     } catch (err) {
//       console.error("Print error", err);
//       toast.error("Unable to print. Check console for details.");
//     }
//   };

//   const handleExportExcel = async () => {
//     if (!tableData.length) return;

//     const wb = new ExcelJS.Workbook();
//     const ws = wb.addWorksheet("Attendance Report");

//     // =========================
//     // COLUMNS
//     // =========================
//     ws.columns = [
//       { header: "S.No", key: "sno", width: 8 },
//       { header: "Emp ID", key: "empId", width: 15 },
//       { header: "Employee", key: "employee", width: 30 },
//       { header: "Designation", key: "designation", width: 20 },
//       { header: "Division", key: "division", width: 18 },
//       { header: "State", key: "state", width: 18 },
//       { header: "HQ", key: "hq", width: 20 },
//       { header: "DOJ", key: "doj", width: 15 },
//       { header: "Manager", key: "manager", width: 20 },
//       { header: "Visits", key: "visits", width: 12 },
//       { header: "POB", key: "pob", width: 12 },
//       { header: "Mor Punch", key: "mor", width: 15 },
//       { header: "Eve Punch", key: "eve", width: 15 },
//       { header: "First Call Time", key: "firstCall", width: 20 },
//       { header: "Last Call Time", key: "lastCall", width: 20 },
//       { header: "Status", key: "status", width: 20 },
//       { header: "Address", key: "address", width: 40 },
//     ];

//     // =========================
//     // ROW DATA (✅ FIXED EMP ID)
//     // =========================
//     tableData.forEach((r, i) => {
//       const empRaw = String(r.employeeCode ?? "").trim();
//       const empIsNum = /^\d+$/.test(empRaw);
//       const empID = empIsNum ? Number(empRaw) : empRaw;

//       const row = ws.addRow({
//         sno: i + 1,
//         empId: empID,
//         employee: r.employeeName,
//         designation: r.designation,
//         division: r.division,
//         state: r.state,
//         hq: r.headquarter,
//         doj: r.final_joining_date ? new Date(r.final_joining_date) : "",
//         manager: r.manager,
//         visits: Number(r.visits || 0),
//         pob: Number(r.pob || 0),
//         mor: r.morningPunchTime
//           ? formatExcelTime(r.morningPunchTime)
//           : "-",
//         eve: r.eveningPunchTime
//           ? formatExcelTime(r.eveningPunchTime)
//           : "-",
//         firstCall: r.firstCallTime
//           ? formatExcelTime(r.firstCallTime)
//           : null,

//         lastCall: r.lastCallTime
//           ? formatExcelTime(r.lastCallTime)
//           : null,
//         status: `${r.morningStatus} / ${r.eveningStatus}`,
//         address: r.residenceAddress,
//       });

//       // ✅ APPLY CORRECT FORMAT (CRITICAL)
//       const empCell = row.getCell("empId");
//       empCell.numFmt = empIsNum ? "0" : "@";
//       const dojCell = row.getCell("doj");
//       if (r.final_joining_date) {
//         dojCell.numFmt = "DD-MMM-YYYY";  // e.g. 10-Feb-2026
//         dojCell.value = new Date(r.final_joining_date);
//       }
//     });

//     // =========================
//     // HEADER STYLE
//     // =========================
//     ws.getRow(1).eachCell((cell) => {
//       cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
//       cell.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "4472C4" },
//       };
//       cell.alignment = {
//         horizontal: "center",
//         vertical: "middle",
//         wrapText: true,
//       };
//     });

//     // =========================
//     // ROW STYLE
//     // =========================
//     ws.eachRow((row, rowNumber) => {
//       row.height = 20;

//       row.eachCell((cell) => {
//         cell.border = {
//           top: { style: "thin" },
//           left: { style: "thin" },
//           bottom: { style: "thin" },
//           right: { style: "thin" },
//         };

//         cell.alignment = {
//           vertical: "middle",
//           horizontal: rowNumber === 1 ? "center" : "left",
//           wrapText: true,
//         };
//       });

//       // Alternate row color
//       if (rowNumber % 2 === 0 && rowNumber !== 1) {
//         row.eachCell((cell) => {
//           cell.fill = {
//             type: "pattern",
//             pattern: "solid",
//             fgColor: { argb: "F5F5F5" },
//           };
//         });
//       }
//     });

//     // =========================
//     // FORMATS
//     // =========================
//     ws.getColumn("doj").numFmt = "DD-MMM-YYYY";
//     ws.getColumn("visits").numFmt = "0";
//     ws.getColumn("pob").numFmt = "#,##0";
//     ws.getColumn("mor").numFmt = "hh:mm AM/PM";
//     ws.getColumn("eve").numFmt = "hh:mm AM/PM";
//     ws.getColumn("firstCall").numFmt = "hh:mm AM/PM";
//     ws.getColumn("lastCall").numFmt = "hh:mm AM/PM";

//     // =========================
//     // FREEZE + FILTER
//     // =========================
//     ws.views = [{ state: "frozen", ySplit: 1 }];
//     ws.autoFilter = { from: "A1", to: "Q1" };

//     // =========================
//     // DOWNLOAD
//     // =========================
//     const buffer = await wb.xlsx.writeBuffer();
//     saveAs(new Blob([buffer]), "Attendance_Report.xlsx");
//   };
//   return (
//     <>
//       <style>{`
//         /* blur the main content when loading */
//         .dpa-blurred {
//           filter: blur(4px);
//           pointer-events: none;
//           user-select: none;
//         }
//         .dpa-loading-overlay {
//           position: fixed;
//           inset: 0;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: rgba(0,0,0,0.35);
//           z-index: 9999;
//         }
//         .dpa-loader-wrapper {
//           background: #fff;
//           padding: 18px;
//           border-radius: 10px;
//           box-shadow: 0 8px 30px rgba(0,0,0,0.2);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }
//       `}</style>

//       {isLoading && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/25">
//           <Loader onCancel={() => setIsLoading(false)} />
//         </div>
//       )}

//       <div className="p-2  border-2 border-gray-300 rounded-lg bg-white">
//         <div className="p-4 border-2 border-gray-300 rounded-lg bg-gray-50">
//           <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
//             <span className="text-blue-700">Punch </span>
//             <span className="text-blue-500">Attendance</span>
//           </h1>

//           <div className="punchedAttendence-filter-row1">
//             <LoadingDropdown
//               label="State"
//               name="state"
//               value={selectedState}
//               onChange={(e) => onStateChange(e.target.value)}
//               isLoading={isFetchingStates}
//               disabled={isLoading}
//             >
//               <option value="All">All</option>
//               {states.map((state) => (
//                 <option
//                   key={state.id ?? state.name}
//                   value={state.id ?? state.name}
//                 >
//                   {state.name}
//                 </option>
//               ))}
//             </LoadingDropdown>

//             <LoadingDropdown
//               label="Division"
//               name="division"
//               value={selectedDivision}
//               onChange={(e) => onDivisionChange(e.target.value)}
//               isLoading={isFetchingDivisions}
//               disabled={!selectedState || isLoading}
//             >
//               {divisions.length === 0 ? (
//                 <option value="All">All</option>
//               ) : (
//                 divisions.map((division) => (
//                   <option
//                     key={division.id ?? division.name}
//                     value={division.name}
//                   >
//                     {division.name}
//                   </option>
//                 ))
//               )}
//             </LoadingDropdown>
//           </div>

//           <div className="punchedAttendence-filter-row2">
//             <LoadingDropdown
//               label="Employee"
//               name="employee"
//               value={selectedEmployee}
//               onChange={(e) => setSelectedEmployee(e.target.value)}
//               isLoading={isFetchingEmployees}
//               disabled={!selectedState || isLoading}
//             >
//               {employees.length === 0 ? (
//                 <option value="All">All</option>
//               ) : (
//                 employees.map((employee) => (
//                   <option key={employee.id} value={employee.id}>
//                     {employee.id === "All"
//                       ? "All"
//                       : `${employee.first_name ?? ""} ${employee.last_name ?? ""} ${employee.employee} -  (${employee.designation ?? ""} | ${employee.headquarter_name ?? ""} | ${employee.division ?? ""} | ${employee.state_name ?? ""})`}
//                   </option>
//                 ))
//               )}
//             </LoadingDropdown>
//             <label className="punchedAttendence-label">Date</label>
//             <input
//               type="date"
//               className="punchedAttendence-dropdown"
//               value={formatDateForDisplay(selectedDate)}
//               onChange={(e) => setSelectedDate(new Date(e.target.value))}
//               disabled={isLoading}
//             />
//           </div>

//           <div className="flex items-center justify-center">
//             <CustomButton
//               type="button"
//               className=""
//               variant="go"
//               onClick={loadAttendanceReport}
//               disabled={isLoading}
//             >
//               {isLoading ? "Loading..." : "GO"}
//             </CustomButton>
//           </div>

//           {error && <div className="punchedAttendence-error">{error}</div>}
//         </div>
//         {showTable && tableData.length > 0 && (
//           <div
//             className=" table-wrapper mt-6 border-2 border-gray-300 rounded-lg bg-white p-3"
//             ref={tableWrapperRef}
//           >
//             <table className="unlock-dcr-leave-table text-sm ">
//               <thead className="bg-blue-500 text-white">
//                 <tr>
//                   <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
//                     S.No
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
//                     Emp ID
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle">
//                     Employee
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle">
//                     Desig
//                     <br />
//                     Div
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle">
//                     State
//                     <br />
//                     Sub State
//                     <br />
//                     HQ
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
//                     DOJ
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle">
//                     Manager
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
//                     MANDATORY
//                     <br />
//                     Can Login
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
//                     Visits
//                     <br />
//                     POB
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
//                     Location
//                     <br />
//                     Count
//                     <br />
//                     GPS Stop
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle w-64 whitespace-normal">
//                     Latest
//                     <br />
//                     Location
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle bg-blue-200 whitespace-nowrap">
//                     Mor Punch Time
//                     <br />
//                     Eve Punch Time
//                   </th>

//                   <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
//                     First Call Time
//                     <br />
//                     Last Call Time
//                   </th>

//                   <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
//                     Mor Fld By
//                     <br />
//                     Eve Fld By
//                   </th>

//                   <th className="border px-2 py-2 text-center align-middle">
//                     Mor Status
//                     <br />
//                     Eve Status
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle whitespace-normal">
//                     Residence Address
//                   </th>
//                   <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
//                     SMS
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {tableData.map((record, index) => (
//                   <tr
//                     key={`${record.employeeId}-${index}`}
//                     className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
//                   >
//                     <td className="border px-2 py-3 text-center align-middle whitespace-nowrap">
//                       {record.serialNumber}
//                     </td>
//                     <td className="border px-2 py-3 text-center align-middle whitespace-nowrap">
//                       {record.employeeCode || "-"}
//                     </td>
//                     <td className="border px-2 py-3 align-middle">
//                       <button
//                         onClick={() => openWorkingWithWindow(record.employeeId)}
//                         className="underline text-blue-600 hover:text-blue-800"
//                       >
//                         {record.employeeName}
//                       </button>
//                     </td>

//                     <td className="border px-2 py-3 text-center align-middle">
//                       <div className="whitespace-normal border-b-2 pb-1">
//                         {record.designation}
//                       </div>
//                       <div className="whitespace-normal">{record.division}</div>
//                     </td>

//                     <td className="border px-2 py-3 text-center align-middle">
//                       <div className="whitespace-normal border-b-2 pb-1">
//                         {record.state}
//                       </div>
//                       <div className="whitespace-normal border-b-2 pb-1">
//                         {record.substate}
//                       </div>
//                       <div className="whitespace-normal">
//                         {record.headquarter}
//                       </div>
//                     </td>

//                     <td className="border px-2 py-3 text-center align-middle whitespace-nowrap">
//                       {record.final_joining_date === "-"
//                         ? "-"
//                         : formatDate(record.final_joining_date) || "-"}
//                     </td>

//                     <td className="border px-2 py-3 align-middle text-center">
//                       {record.manager}
//                     </td>

//                     <td className="border px-2 py-3 text-center align-middle">
//                       <div className="flex flex-col items-center justify-center">
//                         <CheckCircle className="w-5 h-5 text-green-600 mb-1 border-b-2" />
//                         {record.mandatoryCanLogin ? (
//                           <img
//                             src={GreenFlag}
//                             alt="can-login"
//                             className="w-6 h-6 mt-1"
//                           />
//                         ) : (
//                           <img
//                             src={RedFlag}
//                             alt="cannot-login"
//                             className="w-6 h-6 mt-1"
//                           />
//                         )}
//                       </div>
//                     </td>

//                     <td className="border px-2 py-3 text-center align-middle">
//                       <div className="flex flex-col items-center">
//                         <button
//                           onClick={() =>
//                             openDcrPreviewWindow(record.employeeId)
//                           }
//                           className="underline text-blue-600 hover:text-blue-800"
//                         >
//                           <span className="whitespace-nowrap">
//                             {record.visits}
//                           </span>
//                         </button>
//                         <div className="border-t border-gray-200 w-full my-1" />
//                         <button
//                           onClick={() =>
//                             openDcrPreviewWindow(record.employeeId)
//                           }
//                           className="underline text-blue-600 hover:text-blue-800"
//                         >
//                           <span className="whitespace-nowrap">
//                             {typeof record.pob === "number"
//                               ? record.pob.toLocaleString()
//                               : record.pob}
//                           </span>
//                         </button>
//                       </div>
//                     </td>

//                     <td className="border px-2 py-3 text-center align-middle">
//                       <div className="flex flex-col items-center">
//                         <button
//                           onClick={() =>
//                             openLocationHistoryWindow(
//                               record.employeeId,
//                               record.employeeName,
//                             )
//                           }
//                           className="underline text-blue-600 hover:text-blue-800 font-bold"
//                         >
//                           <span className="whitespace-nowrap">
//                             {record.locationCount || 0}
//                           </span>
//                         </button>
//                         <div className="border-t border-gray-200 w-full my-1" />
//                         <button
//                           onClick={() => handleViewMap(record)}
//                           className="underline text-blue-600 hover:text-blue-800 font-semibold"
//                         >
//                           View
//                         </button>
//                       </div>
//                     </td>
//                     <td className="border px-2 py-3 align-middle max-w-[200px] text-xs">
//                       <div
//                         onClick={() => handleOpenDoctorsTPvsDCR(record)}
//                         className="underline text-blue-600 hover:text-blue-800 whitespace-normal break-words border-b-2 pb-1 cursor-pointer"
//                       >
//                         {record.routeName || "-"}
//                       </div>

//                       <div className="text-bold text-red-600 mt-1 border-b-2 pb-1">
//                         {formatDateTime(record.gps_stop_idle_time, true)}
//                       </div>
//                       <button
//                         onClick={() => handleViewMap(record)}
//                         className="underline text-blue-600 hover:text-blue-800 whitespace-normal break-words pt-1"
//                       >
//                         {record.latestLocation || "-"}
//                       </button>
//                     </td>
//                     <td className="border px-2 py-3 text-center align-middle bg-blue-100 whitespace-nowrap">
//                       {record.morningPunchTime ? (
//                         <button
//                           onClick={() => handleMorningPunchMap(record)}
//                           className="underline text-blue-600 hover:text-blue-800 font-semibold"
//                         >
//                           {formatTimeTo12Hour(record.morningPunchTime)}
//                         </button>
//                       ) : (
//                         <span className="inline-block whitespace-nowrap">
//                           -
//                         </span>
//                       )}

//                       <div className="border-t border-gray-200 w-full my-1" />

//                       {record.eveningPunchTime ? (
//                         <button
//                           onClick={() => handleEveningPunchMap(record)}
//                           className="underline text-blue-600 hover:text-blue-800 font-semibold"
//                         >
//                           {formatTimeTo12Hour(record.eveningPunchTime)}
//                         </button>
//                       ) : (
//                         <span className="inline-block whitespace-nowrap">
//                           -
//                         </span>
//                       )}
//                     </td>
//                     <td className="border px-2 py-3 text-center align-middle whitespace-normal text-xs">
//                       <div>{formatDateTime(record.firstCallTime, true)}</div>

//                       <div className="border-t border-gray-200 w-full my-1" />

//                       <div>{formatTimeTo12Hour(record.lastCallTime)}</div>
//                     </td>

//                     <td className="border px-2 py-3 text-center align-middle whitespace-nowrap">
//                       <div className="border-b-2 pb-1">
//                         {capitalizeFirst(record.morningFieldBy)}
//                       </div>
//                       <div>{capitalizeFirst(record.eveningFieldBy)}</div>
//                     </td>

//                     <td className="border px-2 py-3 text-center align-middle">
//                       <div>
//                         <span
//                           className={
//                             record.morningStatus === "Present"
//                               ? "text-green-600 font-semibold"
//                               : "text-red-600 font-semibold"
//                           }
//                         >
//                           {record.morningStatus}
//                         </span>
//                         <br />
//                         <span
//                           className={
//                             record.eveningStatus === "Present"
//                               ? "text-green-600 font-semibold"
//                               : "text-red-600 font-semibold"
//                           }
//                         >
//                           {record.eveningStatus}
//                         </span>
//                       </div>
//                     </td>
//                     <td className="border px-2 py-3 align-middle text-xs">
//                       <button
//                         onClick={() => openMapModal(record, "homeOnly")}
//                         className="underline text-blue-600 hover:text-blue-800"
//                       >
//                         <span className="whitespace-normal break-words">
//                           {record.residenceAddress}
//                         </span>
//                       </button>
//                     </td>
//                     <td className="border px-2 py-3 text-center align-middle whitespace-nowrap">
//                       <button
//                         onClick={() => openSmsModal(record)}
//                         className="underline text-blue-600 hover:text-blue-800"
//                       >
//                         {record.smsStatus}
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//               <tfoot>
//                 <tr className="bg-blue-600 font-bold text-sm">
//                   <td colSpan={8} className="border px-2 py-3 text-center">
//                     TOTAL
//                   </td>

//                   {/* Visits / POB */}
//                   <td className="border px-2 py-3 text-center">
//                     <div>{footerTotals.totalVisits}</div>
//                     <div className="border-t border-gray-400 my-1" />
//                     <div>{footerTotals.totalPob.toLocaleString()}</div>
//                   </td>

//                   <td className="border px-2 py-3 text-center">-</td>
//                   <td className="border px-2 py-3 text-center">-</td>

//                   {/* Punch / No Punch */}
//                   <td className="border px-2 py-3 text-center bg-blue-200">
//                     <div>Punch : {footerTotals.punch}</div>
//                     <div className="border-t border-gray-400 my-1" />
//                     <div>No Punch : {footerTotals.noPunch}</div>
//                   </td>

//                   <td className="border px-2 py-3 text-center">-</td>

//                   {/* Mor / Eve Field */}
//                   <td className="border px-2 py-3 text-center">-</td>

//                   <td className="border px-2 py-3 text-center">
//                     <div className="text-white">
//                       Present : {footerTotals.present}
//                     </div>

//                     <div className="border-t border-gray-400 my-1" />

//                     <div
//                       onClick={() => handleOpenAbsentWindow()}
//                       className="text-red-700 cursor-pointer hover:underline"
//                     >
//                       Absent : {footerTotals.absent}
//                     </div>
//                   </td>

//                   <td className="border px-2 py-3 text-center">-</td>
//                   <td className="border px-2 py-3 text-center">-</td>
//                 </tr>
//               </tfoot>
//             </table>

//             <div className="mt-4 flex gap-4 justify-center">
//               <CustomButton onClick={handlePrint} label="Print" variant="print">
//                 🖨
//               </CustomButton>
//               <CustomButton
//                 onClick={handleExportExcel}
//                 label="Export"
//                 variant="export"
//               >
//                 📥
//               </CustomButton>
//             </div>
//           </div>
//         )}
//         {showTable && tableData.length === 0 && (
//           <div className="text-center py-8 text-gray-500">
//             No attendance data found for the selected filters.
//           </div>
//         )}
//         {smsModal.isOpen && smsModal.employee && (
//           <SmsModal
//             isOpen={smsModal.isOpen}
//             name={smsModal.employee.employeeName}
//             phone={smsModal.employee.phone}
//             onSend={async (payload) => {
//               try {
//                 await axios.post(`${BASE_URL}/api/send-sms`, payload, {
//                   headers: getAuthHeaders(),
//                 });
//               } catch (err) {
//                 console.error("SMS send failed", err);
//                 throw err;
//               }
//             }}
//             onClose={() => setSmsModal({ isOpen: false, employee: null })}
//           />
//         )}
//         {mapModal.isOpen && mapModal.employeeData && (
//           <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-2">
//             <div className="bg-white rounded-lg w-full max-w-7xl h-[95vh] flex flex-col">
//               <div className="flex-1 p-1 overflow-hidden">
//                 <EmployeeMapTracker
//                   key={`${mapModal.employeeData.employeeId}-${mapModal.employeeData.trackDate}-${mapModal.employeeData.context}`}
//                   employeeId={mapModal.employeeData.employeeId}
//                   trackDate={mapModal.employeeData.trackDate}
//                   employeeName={mapModal.employeeData.employeeName}
//                   residenceAddress={mapModal.employeeData.residenceAddress}
//                   specificPunchTime={mapModal.employeeData.specificPunchTime}
//                   onClose={closeMapModal}
//                   context={mapModal.employeeData.context}
//                   isModal={true}
//                   routeName={mapModal.employeeData.routeName}
//                   latestLocation={mapModal.employeeData.latestLocation}
//                   gpsStop={mapModal.employeeData.gpsStop}
//                   locationCount={mapModal.employeeData.locationCount}
//                   gpsStopIdleTime={mapModal.employeeData.gpsStopIdleTime}
//                   visits={mapModal.employeeData.visits}
//                   pob={mapModal.employeeData.pob}
//                 />
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default DailyPunchedAttendance;


import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "../css/DailyPunchedAttendence.css";
import { format } from "date-fns";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import SmsModal from "../Admin/DailyPunchSheets/SmsModal";
import EmployeeMapTracker from "../../src/pages/EmployeeMapTracker";
import RedFlag from "../images/RedFlag.png";
import GreenFlag from "../images/GreenFlag.png";
import Loader from "../dist/Loader";
import { CheckCircle } from "lucide-react";
import CustomButton from "./CustomButton";
import { formatDate } from "../utils/formatDate";
import { formatTimeTo12Hour, formatExcelTime } from "../utils/formatTime";
import AttendanceTable from "../Admin/AbsentDailyPunch";
import LoadingDropdown from "../utils/LoadingDropdown";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const DailyPunchedAttendance = () => {
  const [states, setStates] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("All");
  const [selectedEmployee, setSelectedEmployee] = useState("All");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [smsModal, setSmsModal] = useState({ isOpen: false, employee: null });
  const [isFetchingStates, setIsFetchingStates] = useState(false);
  const [isFetchingDivisions, setIsFetchingDivisions] = useState(false);
  const [isFetchingEmployees, setIsFetchingEmployees] = useState(false);
  const [mapModal, setMapModal] = useState({
    isOpen: false,
    employeeData: null,
  });

  const tableWrapperRef = useRef(null);

  const formatDateForApi = (date) => {
    if (!date) return "";
    const dt = new Date(date);
    const yyyy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const dd = String(dt.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const formatDateTime = (dateString, displayTimeOnly = false) => {
    if (!dateString) return "-";

    const date = new Date(
      dateString.endsWith("Z") ? dateString : `${dateString}Z`,
    );

    const timeOptions = {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    const dateOptions = {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
    };

    const formatTime = (d) =>
      d.toLocaleTimeString("en-IN", timeOptions).toUpperCase();

    if (displayTimeOnly) {
      return formatTime(date);
    }

    const formattedDate = date.toLocaleDateString("en-IN", dateOptions);
    const formattedTime = formatTime(date);

    return `${formattedDate} ${formattedTime}`;
  };

  const capitalizeFirst = (text) =>
    text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "-";

  const handleOpenAbsentWindow = () => {
    const params = new URLSearchParams();

    if (selectedState && selectedState !== "All") {
      params.set("state_id", selectedState);
    }

    if (selectedDivision && selectedDivision !== "All") {
      params.set("division", selectedDivision);
    }

    if (selectedEmployee && selectedEmployee !== "All") {
      params.set("employee_id", selectedEmployee);
    }

    const quarterDate = format(selectedDate, "dd MMM yyyy");
    params.set("quarter", quarterDate.replace(/ /g, "/"));

    params.set("is_absent", "true");

    const url = `/admin/absent-daily-punch?${params.toString()}`;

    window.open(url, "_blank", "width=1000,height=700,left=200,top=100");
  };

  const formatDateForDisplay = (date) => {
    if (!date) return "";
    const d = typeof date === "string" ? new Date(date) : date;
    return format(d, "yyyy-MM-dd");
  };

  // Load states
  const loadStates = async () => {
    setIsFetchingStates(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/states`, {
        headers: getAuthHeaders(),
      });
      const list = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      setStates(list);
    } catch (err) {
      console.error("Error fetching states:", err);
      setError("Failed to load states");
    } finally {
      setIsFetchingStates(false);
    }
  };

  const loadEmployees = async (stateId, divisionName) => {
    if (!stateId || stateId === "All") {
      setEmployees([{ id: "All", first_name: "All", last_name: "" }]);
      setSelectedEmployee("All");
      return;
    }

    setIsFetchingEmployees(true);
    try {
      const params = new URLSearchParams();
      params.set("state_id", stateId);
      if (divisionName && divisionName !== "All")
        params.set("division", divisionName);

      const response = await axios.get(
        `${BASE_URL}/api/employees?${params.toString()}`,
        { headers: getAuthHeaders() },
      );
      const list = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      setEmployees([{ id: "All", first_name: "All", last_name: "" }, ...list]);
      setSelectedEmployee("All");
    } catch (err) {
      console.error("Error fetching employees:", err);
      setEmployees([{ id: "All", first_name: "All", last_name: "" }]);
    } finally {
      setIsFetchingEmployees(false);
    }
  };

  const onStateChange = async (stateId) => {
    setSelectedState(stateId);
    setSelectedDivision("All");
    setSelectedEmployee("All");

    if (!stateId || stateId === "All") {
      setDivisions([{ id: "All", name: "All" }]);
      await loadEmployees("All", "All");
      return;
    }
    setIsFetchingDivisions(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/divisions?state_id=${stateId}`,
        { headers: getAuthHeaders() },
      );
      const divisionsData = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      const divisionsList = divisionsData.map((d) =>
        typeof d === "string" ? { id: d, name: d } : d,
      );
      setDivisions([{ id: "All", name: "All" }, ...divisionsList]);
    } catch (err) {
      console.error("Error loading divisions", err);
      setDivisions([{ id: "All", name: "All" }]);
    } finally {
      setIsFetchingDivisions(false);
    }

    await loadEmployees(stateId, "All");
  };

  const onDivisionChange = (division) => {
    setSelectedDivision(division);
    setSelectedEmployee("All");
    loadEmployees(selectedState === "All" ? null : selectedState, division);
  };

  const loadAttendanceReport = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const params = new URLSearchParams();
      if (selectedState && selectedState !== "All")
        params.set("state_id", selectedState);
      if (selectedDivision && selectedDivision !== "All")
        params.set("division", selectedDivision);
      if (selectedEmployee && selectedEmployee !== "All")
        params.set("employee_id", selectedEmployee);

      const quarterDate = format(selectedDate, "dd MMM yyyy");
      params.set("quarter", quarterDate.replace(/ /g, "/"));

      const url = `${BASE_URL}/api/pob-targets/pob_target_report?${params.toString()}`;
      const response = await axios.get(url, { headers: getAuthHeaders() });

      const responseData = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];

      const transformedData = responseData.map((item, index) => {
        const getFieldValue = (...fieldNames) => {
          for (const fieldName of fieldNames) {
            if (item[fieldName] !== undefined && item[fieldName] !== null)
              return item[fieldName];
          }
          return "";
        };

        const employeeName =
          getFieldValue("employee_name", "employee") ||
          `${getFieldValue("first_name") || ""} ${getFieldValue("last_name") || ""
            }`.trim();

        return {
          serialNumber: index + 1,
          employeeId: getFieldValue("employee_id", "id"),
          employeeCode: getFieldValue("employee"),
          employeeName,
          designation: getFieldValue("designation", "desig") || "",
          division: getFieldValue("division") || "",
          state: getFieldValue("state", "state_name") || "",
          mandatoryCanLogin: getFieldValue("location_active_flag"),
          substate:
            getFieldValue("substate", "sub_state", "zone", "division_zone") ||
            "",
          headquarter:
            getFieldValue("hq", "headquarter", "headquarter_name") || "",
          final_joining_date:
            getFieldValue("final_joining_date", "joining_date", "doj") || "",
          manager: getFieldValue("manager", "manager_name") || "",
          visits: Number(getFieldValue("visits", "visits_count")) || 0,
          pob:
            Number(getFieldValue("pob", "pob_value", "total", "oct_pob")) || 0,
          locationCount:
            Number(getFieldValue("location_count", "locations_count")) || 0,
          gpsStop: getFieldValue("gps_stop", "gps_location", "gpsStop") || "",
          latestLocation:
            getFieldValue(
              "latest_location",
              "current_location",
              "location",
              "latestLocation",
            ) || "",
          routeName: getFieldValue("route_name", "route") || "",
          gps_stop_idle_time:
            getFieldValue("gps_stop_idle_time", "gps_stop_idle") || "",
          morningFieldBy:
            item.morning_fld_by ?? item.mor_field_by ?? item.mor_fld_by ?? "-",
          eveningFieldBy:
            item.evening_fld_by ?? item.eve_field_by ?? item.eve_fld_by ?? "-",
          morningPunchTime:
            getFieldValue("mor_punch_time", "mor_punch", "morning_in_time") ||
            "",
          eveningPunchTime:
            getFieldValue(
              "eve_punch_time",
              "eve_punch",
              "evening_punch_time",
            ) || "",
          firstCallTime: getFieldValue("first_call_time") || "",
          lastCallTime: getFieldValue("last_call_time") || "",
          morningStatus:
            getFieldValue(
              "mor_status",
              "morning_status",
              "attendance_status",
            ) || "Present",
          eveningStatus:
            getFieldValue("eve_status", "evening_status") || "Present",
          residenceAddress: getFieldValue("address", "residence_address") || "",
          phone: getFieldValue("phone_no", "phone_number", "phone") || "",
          smsStatus: getFieldValue("sms") || "No",
        };
      });

      setTableData(transformedData);
      setShowTable(true);
    } catch (err) {
      console.error("Error fetching attendance report:", err);
      setError("Could not load report. Please try again.");
      setTableData([]);
      setShowTable(false);
    } finally {
      setIsLoading(false);
    }
  };

  const openWorkingWithWindow = (employeeId) => {
    const stateId =
      selectedState && selectedState !== "All" ? selectedState : "";
    const month = format(selectedDate, "M");
    const year = format(selectedDate, "yyyy");

    const params = new URLSearchParams();
    if (stateId) params.append("state_id", stateId);
    params.append("month", month);
    params.append("year", year);
    params.append("employee_id", String(employeeId));

    window.open(
      `/admin/working-with?${params.toString()}`,
      "_blank",
      "width=1400,height=700",
    );
  };

  const handleOpenDoctorsTPvsDCR = (record) => {
    const params = new URLSearchParams();
    const formattedDate = format(selectedDate, "MM/dd/yyyy");
    params.set("working_date", formattedDate);
    params.set("employee_id", record.employeeId);
    params.set("emp_name", record.employeeName);
    const url = `/admin/doctors-in-tp-vs-dcr?${params.toString()}`;
    window.open(url, "_blank", "width=1100,height=700,left=200,top=100");
  };

  const openDcrPreviewWindow = (employeeId) => {
    const dateString = formatDateForApi(selectedDate);
    window.open(
      `/admin/dcrpreviewtable?employee_id=${employeeId}&date=${dateString}`,
      "_blank",
      "width=1200,height=700",
    );
  };

  const openLocationHistoryWindow = (employeeId, employeeName) => {
    const params = new URLSearchParams();
    params.set("employee_id", employeeId);
    params.set("employee_name", encodeURIComponent(employeeName || ""));
    params.set("track_date", formatDateForApi(selectedDate));

    window.open(
      `/reporting/location-history?${params.toString()}`,
      "_blank",
      "width=1400,height=700",
    );
  };

  const openMapModal = (employeeData, context = "general") => {
    console.log("Opening map modal with data:", {
      employeeId: employeeData.employeeId,
      employeeName: employeeData.employeeName,
      trackDate: formatDateForApi(selectedDate),
      context: context,
    });

    setMapModal({ isOpen: false, employeeData: null });

    setTimeout(() => {
      setMapModal({
        isOpen: true,
        employeeData: {
          employeeId: String(employeeData.employeeId),
          employeeCode: employeeData.employeeCode,
          employeeName: employeeData.employeeName,
          trackDate: formatDateForApi(selectedDate),
          context: context,
          state: employeeData.state,
          division: employeeData.division,
          designation: employeeData.designation,
          residenceAddress: employeeData.residenceAddress,
          specificPunchTime: employeeData.specificPunchTime || null,
          routeName: employeeData.routeName || "",
          latestLocation: employeeData.latestLocation || "",
          gpsStop: employeeData.gpsStop || "",
          locationCount: employeeData.locationCount ?? 0,
          gpsStopIdleTime:
            formatDateTime(employeeData.gps_stop_idle_time) || "",
          visits: employeeData.visits ?? 0,
          pob: employeeData.pob ?? 0,
        },
      });
    }, 50);
  };

  const closeMapModal = () => {
    setMapModal({ isOpen: false, employeeData: null });
  };

  const handleMorningPunchMap = (employeeData) => {
    console.log("Morning punch clicked for:", employeeData.employeeName);
    openMapModal(
      { ...employeeData, specificPunchTime: employeeData.morningPunchTime },
      "morningPunch",
    );
  };

  const handleEveningPunchMap = (employeeData) => {
    console.log("Evening punch clicked for:", employeeData.employeeName);
    openMapModal(
      { ...employeeData, specificPunchTime: employeeData.eveningPunchTime },
      "eveningPunch",
    );
  };

  const handleViewMap = (employeeData) => {
    console.log("View map clicked for:", employeeData.employeeName);
    openMapModal(employeeData, "viewMap");
  };

  const openSmsModal = (employee) => setSmsModal({ isOpen: true, employee });

  useEffect(() => {
    loadStates();
  }, []);

  useEffect(() => {
    if (mapModal.isOpen && mapModal.employeeData) {
      console.log("Map modal opened with data:", mapModal.employeeData);
    }
  }, [mapModal]);

  const printableStyles = `
    <style>
      body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial; font-size:12px; color:#111; }
      table { border-collapse: collapse; width: 100%; table-layout: fixed; word-break: break-word; }
      th, td { border: 1px solid #999; padding: 6px 8px; vertical-align: middle; }
      thead th { background: #2b6cb0; color: #fff; font-weight: 600; text-align: center; }
      .bg-blue-100 { background-color: #ebf8ff; }
      .text-center { text-align: center; }
      .text-left { text-align: left; }
      .nowrap { white-space: nowrap; }
      .small { font-size: 11px; }
      a { color: #1d4ed8; text-decoration: underline; }
    </style>
  `;

  const getPrintableTableHtml = () => {
    if (!tableWrapperRef.current) return "<div>No table found</div>";
    const wrapper = tableWrapperRef.current.cloneNode(true);
    wrapper.querySelectorAll("button").forEach((btn) => {
      const span = document.createElement("span");
      span.innerHTML = btn.innerHTML;
      btn.parentNode.replaceChild(span, btn);
    });
    wrapper.querySelectorAll("a").forEach((a) => {
      const href = a.getAttribute("href");
      if (href) {
        a.insertAdjacentText("afterend", ` (${href})`);
      }
    });
    return wrapper.innerHTML;
  };

  const footerTotals = tableData.reduce(
    (acc, row) => {
      acc.totalVisits += Number(row.visits || 0);
      acc.totalPob += Number(row.pob || 0);

      const punched =
        Boolean(row.morningPunchTime) || Boolean(row.eveningPunchTime);

      if (punched) acc.punch++;
      else acc.noPunch++;

      const morning = (row.morningStatus || "").toLowerCase().trim();
      const evening = (row.eveningStatus || "").toLowerCase().trim();
      const validStatuses = ["present", "absent"];
      if (
        !validStatuses.includes(morning) ||
        !validStatuses.includes(evening)
      ) {
        return acc;
      }

      if (morning === "absent" && evening === "absent") {
        acc.absent++;
      } else {
        acc.present++;
      }

      return acc;
    },
    {
      totalVisits: 0,
      totalPob: 0,
      punch: 0,
      noPunch: 0,
      present: 0,
      absent: 0,
    },
  );

  const handlePrint = () => {
    try {
      const tableHtml = getPrintableTableHtml();
      const w = window.open("", "_blank", "width=1200,height=900");
      if (!w) {
        toast.warning("Please allow popups to enable printing.");
        return;
      }

      w.document.open();
      w.document.write(
        `<html><head><title>Attendance Report - Print</title>${printableStyles}</head><body>`,
      );
      w.document.write(`<div style="margin:12px 8px;">`);
      w.document.write(`<h2 style="margin-bottom:8px;">Attendance Report</h2>`);
      w.document.write(tableHtml);
      w.document.write(`</div>`);
      w.document.write("</body></html>");
      w.document.close();
      w.focus();
      setTimeout(() => {
        try {
          w.print();
        } catch (e) {
          console.error("Print failed", e);
        }
      }, 500);
    } catch (err) {
      console.error("Print error", err);
      toast.error("Unable to print. Check console for details.");
    }
  };

  const handleExportExcel = async () => {
    if (!tableData.length) return;

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Attendance Report");

    ws.columns = [
      { header: "S.No", key: "sno", width: 8 },
      { header: "Emp ID", key: "empId", width: 15 },
      { header: "Employee", key: "employee", width: 30 },
      { header: "Designation", key: "designation", width: 20 },
      { header: "Division", key: "division", width: 18 },
      { header: "State", key: "state", width: 18 },
      { header: "HQ", key: "hq", width: 20 },
      { header: "DOJ", key: "doj", width: 15 },
      { header: "Manager", key: "manager", width: 20 },
      { header: "Visits", key: "visits", width: 12 },
      { header: "POB", key: "pob", width: 12 },
      { header: "Mor Punch", key: "mor", width: 15 },
      { header: "Eve Punch", key: "eve", width: 15 },
      { header: "First Call Time", key: "firstCall", width: 20 },
      { header: "Last Call Time", key: "lastCall", width: 20 },
      { header: "Status", key: "status", width: 20 },
      { header: "Address", key: "address", width: 40 },
    ];

    tableData.forEach((r, i) => {
      const empRaw = String(r.employeeCode ?? "").trim();
      const empIsNum = /^\d+$/.test(empRaw);
      const empID = empIsNum ? Number(empRaw) : empRaw;

      const row = ws.addRow({
        sno: i + 1,
        empId: empID,
        employee: r.employeeName,
        designation: r.designation,
        division: r.division,
        state: r.state,
        hq: r.headquarter,
        doj: r.final_joining_date ? new Date(r.final_joining_date) : "",
        manager: r.manager,
        visits: Number(r.visits || 0),
        pob: Number(r.pob || 0),
        mor: r.morningPunchTime ? formatExcelTime(r.morningPunchTime) : "-",
        eve: r.eveningPunchTime ? formatExcelTime(r.eveningPunchTime) : "-",
        firstCall: r.firstCallTime ? formatExcelTime(r.firstCallTime) : null,
        lastCall: r.lastCallTime ? formatExcelTime(r.lastCallTime) : null,
        status: `${r.morningStatus} / ${r.eveningStatus}`,
        address: r.residenceAddress,
      });

      const empCell = row.getCell("empId");
      empCell.numFmt = empIsNum ? "0" : "@";
      const dojCell = row.getCell("doj");
      if (r.final_joining_date) {
        dojCell.numFmt = "DD-MMM-YYYY";
        dojCell.value = new Date(r.final_joining_date);
      }
    });

    ws.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "4472C4" },
      };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };
    });

    ws.eachRow((row, rowNumber) => {
      row.height = 20;
      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: rowNumber === 1 ? "center" : "left",
          wrapText: true,
        };
      });

      if (rowNumber % 2 === 0 && rowNumber !== 1) {
        row.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "F5F5F5" },
          };
        });
      }
    });

    ws.getColumn("doj").numFmt = "DD-MMM-YYYY";
    ws.getColumn("visits").numFmt = "0";
    ws.getColumn("pob").numFmt = "#,##0";
    ws.getColumn("mor").numFmt = "hh:mm AM/PM";
    ws.getColumn("eve").numFmt = "hh:mm AM/PM";
    ws.getColumn("firstCall").numFmt = "hh:mm AM/PM";
    ws.getColumn("lastCall").numFmt = "hh:mm AM/PM";

    ws.views = [{ state: "frozen", ySplit: 1 }];
    ws.autoFilter = { from: "A1", to: "Q1" };

    const buffer = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "Attendance_Report.xlsx");
  };

  // ─── Helper: detect leave-type statuses ───────────────────────────────────
  const LEAVE_STATUSES = [
    "leave",
    "sick leave",
    "casual leave",
    "cl",
    "pl",
    "el",
    "sl",
    "holiday",
    "comp off",
    "comp-off",
    "without wages",
  ];

  const isLeaveRow = (record) => {
    const mor = (record.morningStatus || "").toString().trim().toLowerCase();
    const eve = (record.eveningStatus || "").toString().trim().toLowerCase();
    return LEAVE_STATUSES.some(
      (status) => mor.includes(status) || eve.includes(status),
    );
  };
  // ──────────────────────────────────────────────────────────────────────────

  return (
    <>
      <style>{`
        /* blur the main content when loading */
        .dpa-blurred {
          filter: blur(4px);
          pointer-events: none;
          user-select: none;
        }
        .dpa-loading-overlay {
          position: fixed;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0,0,0,0.35);
          z-index: 9999;
        }
        .dpa-loader-wrapper {
          background: #fff;
          padding: 18px;
          border-radius: 10px;
          box-shadow: 0 8px 30px rgba(0,0,0,0.2);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Leave row highlight */
        .leave-highlight-row {
          background-color: #FEF3C7 !important;
          border-left: 4px solid #F59E0B !important;
        }
        .leave-highlight-row td {
          background-color: #FEF3C7 !important;
        }
        /* Keep the blue punch column highlight visible inside leave rows */
        .leave-highlight-row td.punch-col {
          background-color: #FDE68A !important;
        }
      `}</style>

      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/25">
          <Loader onCancel={() => setIsLoading(false)} />
        </div>
      )}

      <div className="p-2 border-2 border-gray-300 rounded-lg bg-white">
        <div className="p-4 border-2 border-gray-300 rounded-lg bg-gray-50">
          <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
            <span className="text-blue-700">Punch </span>
            <span className="text-blue-500">Attendance</span>
          </h1>

          <div className="punchedAttendence-filter-row1">
            <LoadingDropdown
              label="State"
              name="state"
              value={selectedState}
              onChange={(e) => onStateChange(e.target.value)}
              isLoading={isFetchingStates}
              disabled={isLoading}
            >
              <option value="All">All</option>
              {states.map((state) => (
                <option
                  key={state.id ?? state.name}
                  value={state.id ?? state.name}
                >
                  {state.name}
                </option>
              ))}
            </LoadingDropdown>

            <LoadingDropdown
              label="Division"
              name="division"
              value={selectedDivision}
              onChange={(e) => onDivisionChange(e.target.value)}
              isLoading={isFetchingDivisions}
              disabled={!selectedState || isLoading}
            >
              {divisions.length === 0 ? (
                <option value="All">All</option>
              ) : (
                divisions.map((division) => (
                  <option
                    key={division.id ?? division.name}
                    value={division.name}
                  >
                    {division.name}
                  </option>
                ))
              )}
            </LoadingDropdown>
          </div>

          <div className="punchedAttendence-filter-row2">
            <LoadingDropdown
              label="Employee"
              name="employee"
              value={selectedEmployee}
              onChange={(e) => setSelectedEmployee(e.target.value)}
              isLoading={isFetchingEmployees}
              disabled={!selectedState || isLoading}
            >
              {employees.length === 0 ? (
                <option value="All">All</option>
              ) : (
                employees.map((employee) => (
                  <option key={employee.id} value={employee.id}>
                    {employee.id === "All"
                      ? "All"
                      : `${employee.first_name ?? ""} ${employee.last_name ?? ""} ${employee.employee} - (${employee.designation ?? ""} | ${employee.headquarter_name ?? ""} | ${employee.division ?? ""} | ${employee.state_name ?? ""})`}
                  </option>
                ))
              )}
            </LoadingDropdown>
            <label className="punchedAttendence-label">Date</label>
            <input
              type="date"
              className="punchedAttendence-dropdown"
              value={formatDateForDisplay(selectedDate)}
              onChange={(e) => setSelectedDate(new Date(e.target.value))}
              disabled={isLoading}
            />
          </div>

          <div className="flex items-center justify-center">
            <CustomButton
              type="button"
              className=""
              variant="go"
              onClick={loadAttendanceReport}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "GO"}
            </CustomButton>
          </div>

          {error && <div className="punchedAttendence-error">{error}</div>}
        </div>

        {showTable && tableData.length > 0 && (
          <div
            className="table-wrapper mt-6 border-2 border-gray-300 rounded-lg bg-white p-3"
            ref={tableWrapperRef}
          >
            <table className="unlock-dcr-leave-table text-sm">
              <thead className="bg-blue-500 text-white">
                <tr>
                  <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
                    S.No
                  </th>
                  <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
                    Emp ID
                  </th>
                  <th className="border px-2 py-2 text-center align-middle">
                    Employee
                  </th>
                  <th className="border px-2 py-2 text-center align-middle">
                    Desig
                    <br />
                    Div
                  </th>
                  <th className="border px-2 py-2 text-center align-middle">
                    State
                    <br />
                    Sub State
                    <br />
                    HQ
                  </th>
                  <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
                    DOJ
                  </th>
                  <th className="border px-2 py-2 text-center align-middle">
                    Manager
                  </th>
                  <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
                    MANDATORY
                    <br />
                    Can Login
                  </th>
                  <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
                    Visits
                    <br />
                    POB
                  </th>
                  <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
                    Location
                    <br />
                    Count
                    <br />
                    GPS Stop
                  </th>
                  <th className="border px-2 py-2 text-center align-middle w-64 whitespace-normal">
                    Latest
                    <br />
                    Location
                  </th>
                  <th className="border px-2 py-2 text-center align-middle bg-blue-200 whitespace-nowrap">
                    Mor Punch Time
                    <br />
                    Eve Punch Time
                  </th>
                  <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
                    First Call Time
                    <br />
                    Last Call Time
                  </th>
                  <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
                    Mor Fld By
                    <br />
                    Eve Fld By
                  </th>
                  <th className="border px-2 py-2 text-center align-middle">
                    Mor Status
                    <br />
                    Eve Status
                  </th>
                  <th className="border px-2 py-2 text-center align-middle whitespace-normal">
                    Residence Address
                  </th>
                  <th className="border px-2 py-2 text-center align-middle whitespace-nowrap">
                    SMS
                  </th>
                </tr>
              </thead>

              <tbody>
                {tableData.map((record, index) => {
                  // ── Leave row detection ──────────────────────────────
                  const shouldHighlight = isLeaveRow(record);

                  // Row base class
                  const rowClass = shouldHighlight
                    ? "leave-highlight-row"
                    : index % 2 === 0
                    ? "bg-white"
                    : "bg-gray-50";
                  // ────────────────────────────────────────────────────

                  return (
                    <tr
                      key={`${record.employeeId}-${index}`}
                      className={rowClass}
                    >
                      <td className="border px-2 py-3 text-center align-middle whitespace-nowrap">
                        {record.serialNumber}
                      </td>
                      <td className="border px-2 py-3 text-center align-middle whitespace-nowrap">
                        {record.employeeCode || "-"}
                      </td>
                      <td className="border px-2 py-3 align-middle">
                        <button
                          onClick={() =>
                            openWorkingWithWindow(record.employeeId)
                          }
                          className="underline text-blue-600 hover:text-blue-800"
                        >
                          {record.employeeName}
                        </button>
                      </td>

                      <td className="border px-2 py-3 text-center align-middle">
                        <div className="whitespace-normal border-b-2 pb-1">
                          {record.designation}
                        </div>
                        <div className="whitespace-normal">{record.division}</div>
                      </td>

                      <td className="border px-2 py-3 text-center align-middle">
                        <div className="whitespace-normal border-b-2 pb-1">
                          {record.state}
                        </div>
                        <div className="whitespace-normal border-b-2 pb-1">
                          {record.substate}
                        </div>
                        <div className="whitespace-normal">
                          {record.headquarter}
                        </div>
                      </td>

                      <td className="border px-2 py-3 text-center align-middle whitespace-nowrap">
                        {record.final_joining_date === "-"
                          ? "-"
                          : formatDate(record.final_joining_date) || "-"}
                      </td>

                      <td className="border px-2 py-3 align-middle text-center">
                        {record.manager}
                      </td>

                      <td className="border px-2 py-3 text-center align-middle">
                        <div className="flex flex-col items-center justify-center">
                          <CheckCircle className="w-5 h-5 text-green-600 mb-1 border-b-2" />
                          {record.mandatoryCanLogin ? (
                            <img
                              src={GreenFlag}
                              alt="can-login"
                              className="w-6 h-6 mt-1"
                            />
                          ) : (
                            <img
                              src={RedFlag}
                              alt="cannot-login"
                              className="w-6 h-6 mt-1"
                            />
                          )}
                        </div>
                      </td>

                      <td className="border px-2 py-3 text-center align-middle">
                        <div className="flex flex-col items-center">
                          <button
                            onClick={() =>
                              openDcrPreviewWindow(record.employeeId)
                            }
                            className="underline text-blue-600 hover:text-blue-800"
                          >
                            <span className="whitespace-nowrap">
                              {record.visits}
                            </span>
                          </button>
                          <div className="border-t border-gray-200 w-full my-1" />
                          <button
                            onClick={() =>
                              openDcrPreviewWindow(record.employeeId)
                            }
                            className="underline text-blue-600 hover:text-blue-800"
                          >
                            <span className="whitespace-nowrap">
                              {typeof record.pob === "number"
                                ? record.pob.toLocaleString()
                                : record.pob}
                            </span>
                          </button>
                        </div>
                      </td>

                      <td className="border px-2 py-3 text-center align-middle">
                        <div className="flex flex-col items-center">
                          <button
                            onClick={() =>
                              openLocationHistoryWindow(
                                record.employeeId,
                                record.employeeName,
                              )
                            }
                            className="underline text-blue-600 hover:text-blue-800 font-bold"
                          >
                            <span className="whitespace-nowrap">
                              {record.locationCount || 0}
                            </span>
                          </button>
                          <div className="border-t border-gray-200 w-full my-1" />
                          <button
                            onClick={() => handleViewMap(record)}
                            className="underline text-blue-600 hover:text-blue-800 font-semibold"
                          >
                            View
                          </button>
                        </div>
                      </td>

                      <td className="border px-2 py-3 align-middle max-w-[200px] text-xs">
                        <div
                          onClick={() => handleOpenDoctorsTPvsDCR(record)}
                          className="underline text-blue-600 hover:text-blue-800 whitespace-normal break-words border-b-2 pb-1 cursor-pointer"
                        >
                          {record.routeName || "-"}
                        </div>
                        <div className="text-bold text-red-600 mt-1 border-b-2 pb-1">
                          {formatDateTime(record.gps_stop_idle_time, true)}
                        </div>
                        <button
                          onClick={() => handleViewMap(record)}
                          className="underline text-blue-600 hover:text-blue-800 whitespace-normal break-words pt-1"
                        >
                          {record.latestLocation || "-"}
                        </button>
                      </td>

                      {/* Punch time column — uses punch-col class so leave rows show slightly different shade */}
                      <td
                        className={`border px-2 py-3 text-center align-middle whitespace-nowrap ${
                          shouldHighlight ? "punch-col" : "bg-blue-100"
                        }`}
                      >
                        {record.morningPunchTime ? (
                          <button
                            onClick={() => handleMorningPunchMap(record)}
                            className="underline text-blue-600 hover:text-blue-800 font-semibold"
                          >
                            {formatTimeTo12Hour(record.morningPunchTime)}
                          </button>
                        ) : (
                          <span className="inline-block whitespace-nowrap">
                            -
                          </span>
                        )}

                        <div className="border-t border-gray-200 w-full my-1" />

                        {record.eveningPunchTime ? (
                          <button
                            onClick={() => handleEveningPunchMap(record)}
                            className="underline text-blue-600 hover:text-blue-800 font-semibold"
                          >
                            {formatTimeTo12Hour(record.eveningPunchTime)}
                          </button>
                        ) : (
                          <span className="inline-block whitespace-nowrap">
                            -
                          </span>
                        )}
                      </td>

                      <td className="border px-2 py-3 text-center align-middle whitespace-normal text-xs">
                        <div>{formatDateTime(record.firstCallTime, true)}</div>
                        <div className="border-t border-gray-200 w-full my-1" />
                        <div>{formatTimeTo12Hour(record.lastCallTime)}</div>
                      </td>

                      <td className="border px-2 py-3 text-center align-middle whitespace-nowrap">
                        <div className="border-b-2 pb-1">
                          {capitalizeFirst(record.morningFieldBy)}
                        </div>
                        <div>{capitalizeFirst(record.eveningFieldBy)}</div>
                      </td>

                      <td className="border px-2 py-3 text-center align-middle">
                        <div>
                          <span
                            className={
                              record.morningStatus === "Present"
                                ? "text-green-600 font-semibold"
                                : "text-red-600 font-semibold"
                            }
                          >
                            {record.morningStatus}
                          </span>
                          <br />
                          <span
                            className={
                              record.eveningStatus === "Present"
                                ? "text-green-600 font-semibold"
                                : "text-red-600 font-semibold"
                            }
                          >
                            {record.eveningStatus}
                          </span>
                        </div>
                      </td>

                      <td className="border px-2 py-3 align-middle text-xs">
                        <button
                          onClick={() => openMapModal(record, "homeOnly")}
                          className="underline text-blue-600 hover:text-blue-800"
                        >
                          <span className="whitespace-normal break-words">
                            {record.residenceAddress}
                          </span>
                        </button>
                      </td>

                      <td className="border px-2 py-3 text-center align-middle whitespace-nowrap">
                        <button
                          onClick={() => openSmsModal(record)}
                          className="underline text-blue-600 hover:text-blue-800"
                        >
                          {record.smsStatus}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>

              <tfoot>
                <tr className="bg-blue-600 font-bold text-sm">
                  <td colSpan={8} className="border px-2 py-3 text-center">
                    TOTAL
                  </td>

                  {/* Visits / POB */}
                  <td className="border px-2 py-3 text-center">
                    <div>{footerTotals.totalVisits}</div>
                    <div className="border-t border-gray-400 my-1" />
                    <div>{footerTotals.totalPob.toLocaleString()}</div>
                  </td>

                  <td className="border px-2 py-3 text-center">-</td>
                  <td className="border px-2 py-3 text-center">-</td>

                  {/* Punch / No Punch */}
                  <td className="border px-2 py-3 text-center bg-blue-200">
                    <div>Punch : {footerTotals.punch}</div>
                    <div className="border-t border-gray-400 my-1" />
                    <div>No Punch : {footerTotals.noPunch}</div>
                  </td>

                  <td className="border px-2 py-3 text-center">-</td>
                  <td className="border px-2 py-3 text-center">-</td>

                  <td className="border px-2 py-3 text-center">
                    <div className="text-white">
                      Present : {footerTotals.present}
                    </div>
                    <div className="border-t border-gray-400 my-1" />
                    <div
                      onClick={() => handleOpenAbsentWindow()}
                      className="text-red-700 cursor-pointer hover:underline"
                    >
                      Absent : {footerTotals.absent}
                    </div>
                  </td>

                  <td className="border px-2 py-3 text-center">-</td>
                  <td className="border px-2 py-3 text-center">-</td>
                </tr>
              </tfoot>
            </table>

            <div className="mt-4 flex gap-4 justify-center">
              <CustomButton onClick={handlePrint} label="Print" variant="print">
                🖨
              </CustomButton>
              <CustomButton
                onClick={handleExportExcel}
                label="Export"
                variant="export"
              >
                📥
              </CustomButton>
            </div>
          </div>
        )}

        {showTable && tableData.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            No attendance data found for the selected filters.
          </div>
        )}

        {smsModal.isOpen && smsModal.employee && (
          <SmsModal
            isOpen={smsModal.isOpen}
            name={smsModal.employee.employeeName}
            phone={smsModal.employee.phone}
            onSend={async (payload) => {
              try {
                await axios.post(`${BASE_URL}/api/send-sms`, payload, {
                  headers: getAuthHeaders(),
                });
              } catch (err) {
                console.error("SMS send failed", err);
                throw err;
              }
            }}
            onClose={() => setSmsModal({ isOpen: false, employee: null })}
          />
        )}

        {mapModal.isOpen && mapModal.employeeData && (
          <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-2">
            <div className="bg-white rounded-lg w-full max-w-7xl h-[95vh] flex flex-col">
              <div className="flex-1 p-1 overflow-hidden">
                <EmployeeMapTracker
                  key={`${mapModal.employeeData.employeeId}-${mapModal.employeeData.trackDate}-${mapModal.employeeData.context}`}
                  employeeId={mapModal.employeeData.employeeId}
                  trackDate={mapModal.employeeData.trackDate}
                  employeeName={mapModal.employeeData.employeeName}
                  residenceAddress={mapModal.employeeData.residenceAddress}
                  specificPunchTime={mapModal.employeeData.specificPunchTime}
                  onClose={closeMapModal}
                  context={mapModal.employeeData.context}
                  isModal={true}
                  routeName={mapModal.employeeData.routeName}
                  latestLocation={mapModal.employeeData.latestLocation}
                  gpsStop={mapModal.employeeData.gpsStop}
                  locationCount={mapModal.employeeData.locationCount}
                  gpsStopIdleTime={mapModal.employeeData.gpsStopIdleTime}
                  visits={mapModal.employeeData.visits}
                  pob={mapModal.employeeData.pob}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DailyPunchedAttendance;